import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router, RouterLink, RouterLinkActive, NavigationEnd } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { filter, map, startWith } from "rxjs";
import { CommonService } from "../../common.service";
import { SvgIconComponent } from "../../social-icons/svg-icon/svg-icon.component";

@Component({
  selector: "app-side-nav-item",
  templateUrl: "./side-nav-item.component.html",
  styleUrls: ["./side-nav-item.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterLinkActive, RouterLink, SvgIconComponent],
})
export class SideNavItemComponent implements OnInit {
  @Input({ required: true }) public label = "";
  @Input({ required: true }) public navigateTo = "";
  @Input({ required: false }) public image = "";
  @Input({ required: false }) public exactMatch: boolean = false;
  @Input({ required: false }) public alsoActiveFor: string[] = [];

  public navigationLoader: boolean = false;

  private _currentUrl = toSignal(
    this._router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      map((e) => (e as NavigationEnd).urlAfterRedirects),
      startWith(this._router.url),
    ),
  );

  public get isExtraActive(): boolean {
    return this.alsoActiveFor.some((path) => this._currentUrl()?.startsWith(path));
  }

  constructor(
    private _router: Router,
    public commonService: CommonService,
  ) {}

  public ngOnInit(): void {
    if (this.image === "") {
      this.image = this.navigateTo;
    }
  }

  public navigateToUrl(url: string): void {
    this.navigationLoader = true;

    this._router.navigate([url]).finally(() => {
      this.navigationLoader = false;
    });
  }
}
